import ExcelJS from 'exceljs/dist/exceljs.min.js';
import JSZip from 'jszip';

declare global {
  interface Window {
    ExcelJS?: typeof ExcelJS;
    JSZip?: typeof JSZip;
  }
}

const bootstrapGlobals = () => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!window.ExcelJS) {
    window.ExcelJS = ExcelJS;
  }

  if (!window.JSZip) {
    window.JSZip = JSZip;
  }
};

bootstrapGlobals();

export {};